import api from './axios';
import type {
  CustomerCheckResponse,
  CustomerRegistration,
  Customer
} from "../types";

// ============================================================================
// MOCK API CONFIGURATION
// ============================================================================
// Set this to true to use mocked API responses for testing
// Set this to false to use real API endpoints
const USE_MOCK_API = false; // TODO: Change to false when server is ready
// ============================================================================

// Log mock status on module load
if (USE_MOCK_API) {
  console.log('🚀 Mock API is ENABLED - All API calls will return mocked responses');
} else {
  console.log('🌐 Real API is ENABLED - API calls will go to actual endpoints');
}

/**
 * Check if a customer exists in the database
 * @param userId - Firebase user ID
 * @returns Promise<CustomerCheckResponse>
 */
export const checkCustomerExists = async (): Promise<CustomerCheckResponse> => {
  try {
    const response = await api.get<Customer>(`/api/members/me`);
    return {
      exists: true,
      customer: response.data
    };
  } catch (error) {
    console.error('Error checking customer exists:', error);
    return {
      exists: false,
      customer: undefined
    };
  }
};

/**
 * Register a new customer
 * @param customerData - Customer registration data
 * @returns Promise<RegistrationResponse>
 */
export const registerCustomer = async (customerData: CustomerRegistration): Promise<Customer> => {
  try {
    const response = await api.post<Customer>('/api/members/register', customerData);
    return response.data;
  } catch (error) {
    console.error('Error registering customer:', error);
    throw error;
  }
};

/**
 * Convert registration form data to API format
 * @param firebaseUser - Firebase user object
 * @param formData - Registration form data
 * @returns CustomerRegistrationData
 */
export const convertRegistrationData = (
  firebaseUser: any,
  formData: {
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string;
    dateOfBirth?: {
      year: string;
      month: string;
      day: string;
    };
    gender?: string;
    referralCode?: string;
  }
): CustomerRegistration => {
  let dob = '';
  if (formData.dateOfBirth?.year && formData.dateOfBirth?.month && formData.dateOfBirth?.day) {
    dob = new Date(
      parseInt(formData.dateOfBirth.year),
      parseInt(formData.dateOfBirth.month) - 1,
      parseInt(formData.dateOfBirth.day)
    ).toISOString().split('T')[0]; // Format as 'YYYY-MM-DD'
  }

  return {
    firstName: formData.firstName?.trim() || 'Guest',
    lastName: formData.lastName?.trim() || 'User',
    phone: formData.phone || firebaseUser.phoneNumber || "",
    dob: dob,
    gender: formData.gender || null,
    referrer: formData.referralCode || null,
  };
};